var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"nc-button-group-base"},[(_vm.title)?_c('div',[_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"nc-button-group-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }